import { trpc } from "@calcom/trpc/react";
import classNames from "@calcom/ui/classNames";
import { BookerNoticeBanner } from "./BookerNoticeBanner";

export function BookerNotices({ className }: { className?: string }) {
  const { data: notices } = trpc.viewer.public.bookerNotices.useQuery(undefined, { staleTime: 60_000 });

  // A failed or empty notices request must never get in the way of booking, so nothing is rendered.
  if (!notices?.length) return null;

  return (
    <div className={classNames("flex flex-col gap-2", className)} data-testid="booker-notices">
      {notices.map((notice) => (
        <BookerNoticeBanner key={notice.id} notice={notice} />
      ))}
    </div>
  );
}
